<template>
  <div class="container margin-large">
    <b-row align-h="center" align-v="center">
      <b-col sm="auto">
        <b-form  @submit="onSubmit">
          <b-input type="password" placeholder="Enter password" v-model="password"></b-input>
          <b-button class='margin-button-normal' type="submit" >Submit</b-button>
         </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import  * as ConfigurationClient from '../clients/ConfigurationClient'
export default {
  name: 'Login',
  components: {
  },
  props: {
  },
  data () {
    return {
      title: 'Login',
      password: undefined
    }
  },
  watch: {
    $route(to, from) {
    }
  },
  methods: {
    onSubmit: async function(event) {
      var session = require('vue-cookies')
      session.set('bertiebets.admin.key', this.password)
      try {
        var response = await ConfigurationClient.getPredictionSettings()
        this.$router.go(0)
      }catch (err) {
        console.log(err)
        if (err.response.status === 403) session.set('bertiebets.admin.key', null)
      }
    }
  },
  mounted () {
  }
}

</script>

<style >
  .margin-large {
    margin-top: 100px
  }

  .margin-button-normal {
    margin-top: 10px
  }
</style>
